import React from 'react';

export const ROOM_ICON_OPTIONS = [
  { key: 'leaf', label: 'Leaf' },
  { key: 'seed', label: 'Seed' },
  { key: 'grow-light', label: 'Grow Light' },
  { key: 'water-drop', label: 'Water Drop' },
  { key: 'ventilation-fan', label: 'Ventilation Fan' },
  { key: 'grow-room', label: 'Grow Room' },
  { key: 'layers', label: 'Layers' },
  { key: 'climate', label: 'Climate' },
  { key: 'flower', label: 'Flower' },
  { key: 'mother-plant', label: 'Mother Plant' },
  { key: 'clone-cutting', label: 'Clone Cutting' },
  { key: 'drying-room', label: 'Drying Room' },
  { key: 'storage', label: 'Storage' },
  { key: 'equipment', label: 'Equipment' },
];

const LEGACY_ICON_ALIASES = {
  sun: 'grow-light',
  droplet: 'water-drop',
  fan: 'ventilation-fan',
  home: 'grow-room',
  thermometer: 'climate',
  room: 'grow-room',
};

export function normalizeRoomIconKey(value) {
  const key = String(value || '').trim().toLowerCase();
  if (!key) return 'grow-room';
  if (ROOM_ICON_OPTIONS.some((item) => item.key === key)) return key;
  return LEGACY_ICON_ALIASES[key] || 'grow-room';
}

export function getRoomIconLabel(key, t) {
  const normalized = normalizeRoomIconKey(key);
  const translated = typeof t === 'function' ? t(`roomIcon.${normalized}`) : '';
  if (translated && translated !== `roomIcon.${normalized}`) return translated;
  return ROOM_ICON_OPTIONS.find((item) => item.key === normalized)?.label || 'Grow Room';
}

const iconProps = {
  viewBox: '0 0 48 48',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 3.2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': 'true',
  focusable: 'false',
};

function LeafIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <path d="M24 38c0-12 5-23 18-27 1 14-6 23-18 27Z" />
      <path d="M24 38c-1-11-7-18-18-19 1 11 7 17 18 19Z" />
      <path d="M24 38c3-10 9-17 18-27" />
      <path d="M24 38c-4-8-10-14-18-19" />
    </svg>
  );
}

function SeedIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <path d="M23 39c8-1 12-8 10-15-1-5-5-8-10-10-5 2-9 5-10 10-2 7 2 14 10 15Z" />
      <path d="M23 14c0-5 4-9 10-9" />
      <path d="M23 14c-4-5-9-6-14-3" />
      <path d="M23 14c0 8-3 14-9 18" />
      <path d="M11 31c-3 0-6 1-8 3" />
      <path d="M35 31c3 0 6 1 8 3" />
    </svg>
  );
}

function GrowLightIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <path d="M12 17h24a5 5 0 0 1 5 5v4H7v-4a5 5 0 0 1 5-5Z" />
      <path d="M18 17v-5" />
      <path d="M30 17v-5" />
      <path d="M24 26v13" />
      <path d="M14 36l-5 6" />
      <path d="M34 36l5 6" />
      <path d="M15 22h.1M22 22h.1M29 22h.1M36 22h.1" />
    </svg>
  );
}

function WaterDropIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <path d="M24 6c8 9 13 17 13 25a13 13 0 0 1-26 0c0-8 5-16 13-25Z" />
      <path d="M30 30c-1 4-3 6-7 7" />
      <path d="M12 36c-4 1-7 3-7 6 0 4 9 6 19 6s19-2 19-6c0-3-3-5-7-6" transform="translate(0 -4)" />
    </svg>
  );
}

function FanIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <circle cx="24" cy="24" r="4" />
      <path d="M24 20c-1-8 4-13 12-12 2 7-3 12-12 12Z" />
      <path d="M27 26c7 4 8 11 2 16-7-2-8-9-2-16Z" />
      <path d="M21 26c-7 4-13 1-15-6 5-5 12-3 15 6Z" />
      <path d="M38 13a18 18 0 1 1-4-4" />
      <path d="M39 8l4 5-6 3" />
    </svg>
  );
}

function GrowRoomIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <path d="M6 22 24 10l18 12" />
      <path d="M11 20v22h26V20" />
      <path d="M24 42V24" />
      <path d="M24 24c-7 3-10 8-8 15 6-1 9-5 8-15Z" />
      <path d="M24 24c7 3 10 8 8 15-6-1-9-5-8-15Z" />
    </svg>
  );
}

function LayersIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <path d="m24 7 18 9-18 9-18-9 18-9Z" />
      <path d="m6 24 18 9 18-9" />
      <path d="m6 32 18 9 18-9" />
    </svg>
  );
}

function ClimateIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <path d="M22 8v23a8 8 0 1 1-9 0V8a4.5 4.5 0 0 1 9 0Z" />
      <path d="M17.5 31v-9" />
      <path d="M32 13h8" />
      <path d="M34 23h6" />
      <path d="M31 33h9" />
      <path d="M8 18c-2 3-2 6 0 9" />
    </svg>
  );
}

function FlowerIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <path d="M24 18c3-8 8-11 13-10 1 6-2 11-10 14 8 3 11 8 10 14-6 1-11-2-14-10-3 8-8 11-14 10-1-6 2-11 10-14-8-3-11-8-10-14 6-1 11 2 15 10Z" />
      <circle cx="24" cy="24" r="4" />
    </svg>
  );
}

function MotherPlantIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <path d="M24 39V14" />
      <path d="M24 23c-7-6-13-7-17-3 1 7 7 10 17 7" />
      <path d="M24 23c7-6 13-7 17-3-1 7-7 10-17 7" />
      <path d="M24 15c-1-6 2-10 6-12 4 5 3 10-6 16" />
      <path d="M24 34c-6-5-11-5-15-2 1 6 6 8 15 5" />
      <path d="M24 34c6-5 11-5 15-2-1 6-6 8-15 5" />
      <path d="M14 43h20" />
    </svg>
  );
}

function CloneCuttingIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <path d="M18 40c-1-8 1-15 6-21" />
      <path d="M25 19c8-4 14-3 17 2-4 6-10 8-17 2Z" />
      <path d="M22 28c-7-4-13-3-16 2 4 6 10 7 16 2Z" />
      <path d="M14 40c-3 1-5 3-6 6" />
    </svg>
  );
}

function DryingRoomIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <path d="M7 22 24 11l17 11" />
      <path d="M11 21v21" />
      <path d="M37 21v21" />
      <path d="M24 15v10" />
      <path d="M18 30c2-5 4-7 6-7s4 2 6 7" />
      <path d="M24 30v8" />
      <path d="M19 37c4 3 6 3 10 0" />
    </svg>
  );
}

function StorageIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <path d="M15 13h18l2 5H13l2-5Z" />
      <path d="M14 18h20v23a3 3 0 0 1-3 3H17a3 3 0 0 1-3-3V18Z" />
      <path d="M18 29h12" />
      <path d="M18 36h12" />
    </svg>
  );
}

function EquipmentIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <path d="M8 18h32v22H8V18Z" />
      <path d="M18 18v-5h12v5" />
      <path d="m17 29-7 7" />
      <path d="m10 29 7 7" />
      <path d="m31 29 7 7" />
      <path d="m38 29-7 7" />
    </svg>
  );
}

const ICONS = {
  leaf: LeafIcon,
  seed: SeedIcon,
  'grow-light': GrowLightIcon,
  'water-drop': WaterDropIcon,
  'ventilation-fan': FanIcon,
  'grow-room': GrowRoomIcon,
  layers: LayersIcon,
  climate: ClimateIcon,
  flower: FlowerIcon,
  'mother-plant': MotherPlantIcon,
  'clone-cutting': CloneCuttingIcon,
  'drying-room': DryingRoomIcon,
  storage: StorageIcon,
  equipment: EquipmentIcon,
};

export function RoomIcon({ iconKey, className = '' }) {
  const normalized = normalizeRoomIconKey(iconKey);
  const Icon = ICONS[normalized] || GrowRoomIcon;
  return <Icon className={className} />;
}
